import Vue from 'vue'
import VueRouter from 'vue-router'

import PatientMain from '../views/patient/main/Main.vue'
import ForgotPassword from '../views/patient/forgot-passoword/ForgotPassword.vue'
import Register from '../views/patient/register/Register.vue'
import ProfessionalVideo from '../views/professional/video/ProfessionalVideo.vue'
import CabineVideo from '../views/patient/video/CabineVideo.vue'
import Nps from '../views/patient/nps/Nps.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'PatientMain',
    component: PatientMain
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/profissional-teste',
    name: 'ProfesseonalVideo',
    component: ProfessionalVideo
  },
  {
    path: '/webview/sala',
    name: 'WebviewRoom',
    component: CabineVideo
  },
  {
    path: '/nps',
    name: 'Nps',
    component: Nps
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
